import { Injectable } from '@angular/core';

@Injectable()
export abstract class HWServiceConfig {
  abstract getPhotoServiceAddress(): string;
  abstract getPhotoControllerV1Address(): string;
  abstract getPhotoControllerV1PreviewAddress(suffix: string): string;
  abstract getPhotoControllerV2Address(): string;
  abstract getHWServiceUrl(): string;
  abstract getCameraServiceProtocol(): string;
  abstract getPortraitServiceProtocol(): string;
  abstract getFingerPrintsServiceProtocol(): string;
  abstract getPassportReaderServiceProtocol(): string;
  abstract getSystemServiceProtocol(): string;
  abstract getLcodServiceProtocol(): string;
  abstract getBCScannerServiceProtocol(): string;
  abstract getSignatureScannerServiceProtocol(): string;
  abstract getCryptoServiceProtocol(): string;
  abstract getTransportServiceProtocol(): string;
  abstract getOpticScannerProtocol(): string;
  abstract getTouchScreenProtocol(): string;
}
